import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Droplets, MessageSquare } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

const PHONE = "646-657-5213";

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 h-16 bg-white/95 backdrop-blur-md border-b border-gray-100 z-50"
    >
      <div className="max-w-3xl mx-auto h-full flex items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          data-testid="wordmark-home-link"
          className="flex items-center gap-2 text-[#334E68]"
        >
          <Droplets className="w-5 h-5 text-[#16A34A]" strokeWidth={2.5} />
          <span className="font-display text-lg font-bold tracking-tight">
            Green Services
          </span>
        </Link>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              data-testid="menu-open-button"
              aria-label="Open menu"
              className="p-2 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg hover:bg-gray-100 text-[#334E68]"
            >
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[85vw] sm:w-[380px] p-0">
            <SheetHeader className="p-6 border-b border-gray-100">
              <SheetTitle className="font-display text-xl text-[#334E68] text-left">
                Menu
              </SheetTitle>
              <SheetDescription className="sr-only">
                Site navigation
              </SheetDescription>
            </SheetHeader>
            <nav className="p-6 space-y-2">
              <Link
                to="/"
                data-testid="menu-link-home"
                onClick={() => setOpen(false)}
                className="block w-full min-h-[56px] px-4 flex items-center rounded-xl text-base font-medium text-[#334E68] hover:bg-gray-50"
              >
                Home
              </Link>
              <Link
                to="/estimate"
                data-testid="menu-link-estimate"
                onClick={() => setOpen(false)}
                className="block w-full min-h-[56px] px-4 flex items-center rounded-xl text-base font-medium text-[#334E68] hover:bg-gray-50"
              >
                Get Estimate
              </Link>
              <div className="pt-4 mt-4 border-t border-gray-100">
                <p className="text-xs uppercase tracking-wider text-gray-400 px-4 mb-2">
                  Contact
                </p>
                <a
                  href={`sms:${PHONE.replace(/-/g, "")}`}
                  data-testid="menu-phone-link"
                  className="w-full min-h-[56px] px-4 flex items-center gap-3 rounded-xl text-base font-medium text-[#16A34A] hover:bg-green-50"
                >
                  <MessageSquare className="w-5 h-5" />
                  Text: {PHONE}
                </a>
              </div>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-gray-100 bg-white py-8 mt-16"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-sm text-gray-500 flex flex-col gap-2 items-center text-center">
        <div className="flex items-center gap-2 text-[#334E68] font-medium">
          <Droplets className="w-4 h-4 text-[#16A34A]" />
          <span className="font-display">Green Services</span>
        </div>
        <a
          href={`sms:${PHONE.replace(/-/g, "")}`}
          data-testid="footer-phone-link"
          className="text-[#334E68] font-medium"
        >
          Text us: {PHONE}
        </a>
        <p>© 2026 Green Services · Hoboken, NJ</p>
      </div>
    </footer>
  );
}
